// src/styles/timerControlsStyles.js
import { styled } from 'baseui';

export const TimerTitle = styled('div', ({ $theme }) => ({
  ...$theme.typography.HeadingMedium,
  color: $theme.colors.contentPrimary,
  marginBottom: $theme.sizing.scale300,
}));

export const TimerValue = styled('div', ({ $theme }) => ({
  ...$theme.typography.DisplayLarge,
  color: $theme.colors.contentPrimary,
  lineHeight: '1.2',
  marginBottom: $theme.sizing.scale600,
}));

export const SliderContainer = styled('div', ({ $theme }) => ({
  width: '100%',
  maxWidth: '600px',
  margin: `0 auto ${$theme.sizing.scale600} auto`,
}));

export const ControlsContainer = styled('div', ({ $theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: $theme.sizing.scale400,
  marginBottom: $theme.sizing.scale600,
  flexWrap: 'wrap',
}));

export const StepButtonsContainer = styled('div', ({ $theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: $theme.sizing.scale400,
  [`@media screen and (max-width: ${$theme.breakpoints.medium}px)`]: {
    gap: $theme.sizing.scale200,
  },
}));

export const StepButtonGroup = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 'inherit',
});

export const TimeUnitLabel = styled('span', ({ $theme }) => ({
  marginLeft: $theme.sizing.scale100,
  color: $theme.colors.contentSecondary,
}));

export const StepInputOverrides = {
  Root: {
    style: {
      width: '70px',
    },
  },
  Input: {
    style: {
      textAlign: 'center',
    },
  },
};